<template>
  <div>
    <vxe-grid
      ref="noticeTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="noticeOrderCode"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:noticeByName="{ row }">
        <span>{{ row.noticeByName }}</span>
        <br />
        <span>{{ row.noticeTime }}</span>
      </template>
      <template v-slot:noticeOrderStatus="{ row }">
        <el-tag
          v-if="row.v_noticeOrderStatus"
          size="mini"
          :type="row.noticeOrderStatus == 'N' ? '' : 'success'"
        >
          {{ row.v_noticeOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:noticeCostStatus="{ row }">
        <el-tag
          v-if="row.v_noticeCostStatus"
          size="mini"
          :type="
            row.noticeCostStatus == 'N'
              ? ''
              : row.noticeCostStatus == 'P'
              ? 'danger'
              : 'success'
          "
        >
          {{ row.v_noticeCostStatus }}
        </el-tag>
      </template>
      <template v-slot:noticePlanStatus="{ row }">
        <el-tag
          v-if="row.v_noticePlanStatus"
          size="mini"
          :type="
            row.noticePlanStatus == 'N'
              ? ''
              : row.noticePlanStatus == 'P'
              ? 'danger'
              : 'success'
          "
        >
          {{ row.v_noticePlanStatus }}
        </el-tag>
      </template>
      <template v-slot:orderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'D' || row.orderStatus === 'T'
              ? 'danger'
              : row.orderStatus === 'R'
              ? 'warning'
              : row.orderStatus === 'Y' ||
                row.orderStatus === 'P' ||
                row.orderStatus === 'C'
              ? 'success'
              : 'light'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, ...row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
        custCode: chooseTemplateOptions.custCode || '',
      }"
      :exportOptions="{
        params: chooseTemplateOptions.params,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
import ChooseTemplate from '@/views/factory/plan/components/choose-template'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { ChooseTemplate },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      chooseTemplateOptions: {
        visible: false,
        templateGroup: '',
        exportCheckUrl: '',
        params: {},
        custCode: '',
      },
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
    ...mapState('admin/user', ['info']),
  },
  methods: {
    optCommand({ opt, noticeOrderCode, orderCode, orderNo, factoryOrderNo, custCode }) {
      if (!opt) return
      const { menuType, data } = opt
      if (!menuType) return      

      switch (menuType) {
        case 'detail':
          this.$router.push({
            name: 'plan-noticeProductionOrder-detail',
            params: { orderCode, orderNo },
          })
          break
        case 'order-export':
          this.export({ noticeOrderCode, ...data, custCode })
          break
        case 'nc-export':
          this.export({ noticeOrderCode, ...data })
          break
        case 'nc':
          this.$emit('set-nc', noticeOrderCode)
          break
        case 'cost':
          this.pdCosts({ noticeOrderCode, orderNo })
          break
        case 'plan':
          this.generatePlan({ noticeOrderCode })
          break
        case 'assignment':
          this.assignment({ noticeOrderCode })
          break
        case 'updateFactory':
          this.updateFactory({ noticeOrderCode, factoryOrderNo })
          break
        case 'rollback':
          this.rollbackNCStatus({ noticeOrderCode})
          break
      }
    },
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.noticeTable.clearCheckboxRow()
      this.$refs.noticeTable.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    assignment({ noticeOrderCode }) {
      this.$emit('openChooseAssignment', [{ noticeOrderCode }])
    },
    updateFactory({ noticeOrderCode, factoryOrderNo }) {
      this.$emit('updateFactoryOrderNo', [{ noticeOrderCode, factoryOrderNo }])
    },
    rollbackNCStatus({ noticeOrderCode}) {
      this.$emit('rollbackNCStatus', { noticeOrderCode })
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.noticeTable
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
    generatePlan({ noticeOrderCode }) {
      this.$confirm(
        '是否要将该生产订单通知书生成生产计划？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .noticeOrderGeneratePlanApi({ noticeOrderCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    pdCosts({ noticeOrderCode, orderNo }) {
      this.$confirm(
        '是否要将该生产订单通知书进行成本核算？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .noticeOrderPdCostsCalcApi({ noticeOrderCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
          type: 'success',
        })
        this.$emit('reload')
        const { body: pdCostsOrderCode } = res
        if (!pdCostsOrderCode) return
        this.$router.push({
          name: 'plan-pdCostsOrder-detail',
          params: { pdCostsOrderCode, pageType: 'edit' },
          query: { orderNo },
        })
      })
    },
    export({ noticeOrderCode, templateGroup, exportCheckUrl, params, custCode }) {
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup,
        exportCheckUrl,
        params: { ...(params || {}), noticeOrderCode },
        custCode:custCode
      }
    },
  },
}
</script>
